<script setup lang="ts">
const props = defineProps<{
  disabled: boolean;
  icon: string;
  title: string;
  to: string;
}>();

function activeNavItemClass() {
  const { fullPath } = useRoute();
  const path = fullPath.indexOf('?') > 0 ? fullPath.slice(0, fullPath.indexOf('?')) : fullPath;
  const activeClasses = '!text-primary-500';

  if (props.to === '/') {
    return path === props.to ? activeClasses : '';
  }

  if (path.startsWith(props.to)) {
    return activeClasses;
  }

  return '';
}
</script>

<template>
  <NuxtLink
    :to="!disabled ? to : ''"
    no-prefetch
    class="flex flex-col justify-center text-center items-center transition-[width] duration-500 px-5 py-1 overflow-hidden"
    :class="[activeNavItemClass(), { 'cursor-not-allowed': props.disabled }]"
  >
    <Icon class="transition-all duration-200" :name="icon" size="18" :class="{ 'text-gray-400': props.disabled }" />
    <span
      class="group/title text-xs mt-1 overflow-hidden transition-all duration-500"
      :class="{ 'text-gray-400': props.disabled }"
      >{{ title }}</span
    >
  </NuxtLink>
</template>
